import React from 'react';
import { SuccessPaymentModalContainer } from './SuccessPaymentModal.style';
import CalendarSuccessSVG from './CalendarSuccessSVG';
import { useHistory } from 'react-router';
import { PrivateRoutes } from '../../../routes/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { lastActiveSubscriptionSelector } from '../../../redux/subscriptions/selector';
import { FormattedMessage } from 'react-intl';
import { CustomButton } from '@mindly/ui-components';
import { setIsModalOpened } from 'src/redux/mindlyReviews/reducer';

type SuccessPaymentModalProps = {
  therapistID: string | null;
};

const SuccessPaymentModal: React.FC<SuccessPaymentModalProps> = ({ therapistID }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const activeConsultation = useSelector(lastActiveSubscriptionSelector(therapistID ?? ''));

  return (
    <SuccessPaymentModalContainer>
      <CalendarSuccessSVG className={'success-icon'} />
      <h3>
        <FormattedMessage id={'subscriptions.pay.success'} defaultMessage={'Підписку придбано'} />
      </h3>
      <p>
        <FormattedMessage id={'subscriptions.pay.success.text'} defaultMessage={'А тепер записуймося на сеанс'} />
      </p>
      <CustomButton
        buttonType={'primary'}
        className={'subscribe-btn'}
        onClick={() =>
          history.push(
            PrivateRoutes.SUBSCRIPTION_BOOKING.replace(':id', therapistID ?? '').replace(
              ':subscriptionID',
              activeConsultation?.id ?? ''
            )
          )
        }
      >
        <FormattedMessage id={'schedule.signIn.session'} defaultMessage={'Записатися на сеанс'} />
      </CustomButton>
      <h4
        onClick={() => {
          setTimeout(() => {
            dispatch(setIsModalOpened(true));
          }, 0);
          history.push(PrivateRoutes.CONSULTATION);
        }}
      >
        <FormattedMessage id={'subscribe.letter'} defaultMessage={'Ні, я запишуся пізніше'} />
      </h4>
    </SuccessPaymentModalContainer>
  );
};

export default SuccessPaymentModal;
